import { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';

interface AlertsDetectOriginHookProps {
  children: ReactNode;
}

interface IAlertsDetectOriginContext {
  isAlertsReferrer: boolean;
}

const AlertsDetectOriginContext = createContext<IAlertsDetectOriginContext | null>(null);

const AlertsDetectOriginProvider: FC<AlertsDetectOriginHookProps> = ({ children }) => {
  const [isAlertsReferrer, setIsAlertsReferrer] = useState<boolean>(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const referrerSource = queryParams.get('ref');
    const alertsReferrer = 'alerts-dashboard';

    setIsAlertsReferrer(referrerSource === alertsReferrer);
  }, [location.search]);

  return (
    <AlertsDetectOriginContext.Provider value={{ isAlertsReferrer }}>{children}</AlertsDetectOriginContext.Provider>
  );
};

function useAlertsDetectOriginProvider(): IAlertsDetectOriginContext {
  const alertsDetectOriginContext = useContext(AlertsDetectOriginContext);

  if (!alertsDetectOriginContext) {
    throw new Error('useAlertsDetectOriginProvider must be used within an AlertsDetectOriginProvider');
  }

  return alertsDetectOriginContext;
}

export { AlertsDetectOriginProvider, useAlertsDetectOriginProvider };
